import type React from 'react';
import type { Control } from '../../types/controls';
import { CUSTOMER_DIMENSION, INSTANCE_DIMENSION } from '../../types/controls';
import { CustomerControl } from './CustomerControl';
import { DeploymentControl } from './DeploymentControl';
import { DropdownControl } from './DropdownControl';
import { TextFieldControl } from './TextFieldControl';
import type { ControlComponentProps } from './types';

/**
 * Maps a control to its component. Unknown or absent types fall back to the dropdown —
 * the same forgiving strategy the widget renderer uses — so a backend that introduces a
 * new control type degrades gracefully instead of breaking the bar.
 */
const REGISTRY: Record<string, React.FC<ControlComponentProps>> = {
  dropdown: DropdownControl,
  textfield: TextFieldControl,
};

/**
 * Dimensions with a portal-backed picker of their own, resolved before the type dispatch below.
 * Adding the next cascade step is an entry here plus its component.
 */
const BY_DIMENSION: Record<string, React.FC<ControlComponentProps>> = {
  [CUSTOMER_DIMENSION]: CustomerControl,
  [INSTANCE_DIMENSION]: DeploymentControl,
};

export const resolveControlComponent = (control: Control): React.FC<ControlComponentProps> =>
  BY_DIMENSION[control.dimension] ?? ((control.type && REGISTRY[control.type]) || DropdownControl);
